<template>
  <div>
    <Head title="Neue Prüfung erstellen"/>
    <h1 class="h1">
      <Link class="text-primary-400 hover:text-primary-600" href="/admin/exam">{{ __('exam.singular') }} </Link>
      <span class="text-primary-400 font-medium">/ {{ __('general.create') }}</span>
    </h1>

    <div :class="{'lg:grid-cols-2' : !showSortingMode}" class="grid grid-cols-1 gap-8">
      <div v-if="!showSortingMode" class="column">
        <h2 class="font-semibold md:text-lg mb-4">Allgemeine Einstellungen</h2>
        <div class="card">

          <form @submit.prevent="update">
            <div class="mb-5">
              <label class="form-label" for="name">
                {{ __('form.name') }}
              </label>
              <input v-model="form.name" class="form-input bg-gray-100" type="text" :placeholder="__('form.name')">
              <p class="text-gray-500 italic text-xs mt-2">{{ __('general.lorem') }}</p>
            </div>

<!--            <div class="mb-5">-->
<!--              <label class="form-label" for="name">-->
<!--                {{ __('form.desc') }}-->
<!--              </label>-->
<!--              <input v-model="form.desc" class="form-input bg-gray-100" type="text" :placeholder="__('form.desc')">-->
<!--              <p class="text-gray-500 italic text-xs mt-2">{{ __('general.lorem') }}</p>-->
<!--            </div>-->

            <div class="mb-5">
              <label for="publish" class="inline-flex relative items-center cursor-pointer mb-2">Kategorie</label>
              <Multiselect
                  v-model="form.category_id"
                  mode="single"
                  :attr="{id}"
                  :close-on-select="true"
                  :searchable="true"
                  :create-option="false"
                  :options="categories"
              />
            </div>

            <div class="grid grid-cols-2 gap-4">
              <div class="mb-5">
                <label class="form-label" for="name">
                  {{ __('form.year') }}
                </label>
                <select v-model="form.year" class="form-select">
                  <option v-for="year in yearOptions" :value="year">{{ year }}</option>
                </select>
                <p class="text-gray-500 italic text-xs mt-2">{{ __('general.lorem') }}</p>
              </div>
              <div class="mb-5">
                <label class="form-label" for="name">
                  {{ __('form.half') }}
                </label>
                <select v-model="form.half" class="form-select">
                  <option :value="1">1. Halbjahr</option>
                  <option :value="2">2. Halbjahr</option>
                </select>
                <p class="text-gray-500 italic text-xs mt-2">{{ __('general.lorem') }}</p>
              </div>
            </div>

            <div class="my-10">
              <label for="publish" class="inline-flex relative items-center cursor-pointer">
                <input v-model="form.status" id="publish" type="checkbox" class="sr-only peer">
                <div :class="toggleClass"
                     class=" w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"
                ></div>
                <span class="ml-3 text-sm font-medium text-gray-900">Prüfungen veröffentlichen</span>
              </label>
            </div>

            <div class="flex justify-between">
              <loading-button class="btn w-auto inline-flex btn-danger" type="button" @click="destroy"><i class="fa fa-trash mr-2"></i> {{ __('exam.delete') }}</loading-button>
              <loading-button class="btn w-auto inline-flex btn-primary" type="submit"><i class="fa fa-save mr-2"></i> {{ __('exam.save') }}</loading-button>
            </div>
          </form>

        </div>
      </div>

      <div class="column">
        <div class="scrollable mh-[500px] overflow-y-scroll">
          <h2 class="font-semibold md:text-lg mb-4">Prüfungsfragen verwalten</h2>

          <div v-if="!showSortingMode" class="mb-5">
            <label class="form-label" for="name">
              {{ __('question.search') }} {{ keyword }}
            </label>
            <input @input="debounceAnswer" class="form-input" type="text" :placeholder="__('question.search')">
          </div>

          <div class="draggable__wrapper">
            <draggable
                v-model="selectedQuestions"
                @start="drag=true"
                @end="drag=false"
                @change="orderChanged"
                ghost-class="ghost-class"
                item-key="id">
              <template #item="{element, index}">
                <question-list-item
                    :question="element"
                    :sorting-mode="showSortingMode"
                    :index="index" @open-modal="prepareQuestionModal"></question-list-item>
              </template>
            </draggable>
          </div>
          <alert v-if="wasOrderChanged" type="warning" class="">
            <i class="fa fa-info-circle mr-2"></i> {{ __('exam.order_was_changed') }}
          </alert>
          <div class="flex justify-end mt-5 gap-4">
            <div class="">
              <label for="show_sort" class="inline-flex relative items-center cursor-pointer">
                <input v-model="showSortingMode" id="show_sort" type="checkbox" class="sr-only peer">
                <div :class="toggleSortingClass"
                     class=" w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"
                ></div>
                <span class="ml-3 text-sm font-medium text-gray-900">Sortiermodus aktivieren</span>
              </label>
            </div>
            <button v-if="!showSortingMode" class="btn w-auto inline-flex btn-primary" @click="addQuestion">{{ __('exam.add_question') }}</button>
            <loading-button v-if="wasOrderChanged" :loading="isOrderLoading" class="btn w-auto inline-flex btn-warning" @click="saveOrder" type="submit">
              {{ __('exam.save_order') }}
            </loading-button>
          </div>
        </div>
      </div>
    </div>

    <modal :show="showQuestionModal"
           :question="currentQuestion"
           :categories="questionCategories"
           @close="toggleQuestionModal"
           @question-updated="onQuestionUpdated"
           @question-deleted="onQuestionDeleted"
           @question-created="onQuestionCreated"></modal>
  </div>
</template>

<style src="@vueform/multiselect/themes/default.css"></style>
<style>
  .draggable__wrapper {
    max-height: 60vh;
    overflow-y: scroll;
    padding-right: 30px;
  }
</style>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Multiselect from '@vueform/multiselect'
import draggable from 'vuedraggable'
import QuestionListItem from '../../Shared/Admin/QuestionListItem'
import LoadingButton from '@/Shared/LoadingButton'

import {postQuestionOrder} from '../../api/QuestionApi'

// import FileInput from '@/Shared/FileInput'
// import TextInput from '@/Shared/TextInput'
// import SelectInput from '@/Shared/SelectInput'
// import LoadingButton from '@/Shared/LoadingButton'
import Modal from '@/Shared/Admin/QuestionEditModal'

export default {
  components: {
    QuestionListItem,
    // FileInput,
    Head,
    Link,
    Multiselect,
    draggable,
    LoadingButton,
    Modal,
    // SelectInput,
    // TextInput,
  },

  layout: Layout,

  props: {
    exam: {
      type: Object,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    questionCategories: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      showQuestionModal: false,
      currentQuestion: null, // the selected question
      selectedQuestions: [],
      isTyping: false,
      debounce: null,
      keyword: null,
      timeout: 300,
      isOrderLoading: false,
      drag: false,
      category: null,
      examModel: {},
      isPublishVar: false,
      wasOrderChanged: false,
      showSortingMode: false,
      form: this.$inertia.form({
        name: this.exam.name,
        desc: this.exam.desc,
        half: this.exam.half,
        year: this.exam.year,
        status: (this.exam.status === 1),
        category_id: this.exam.category_id,
        questions: this.exam.questions,
      }),
      yearOptions: [2021,2022,2023,2024,2025],
      newQuestionModal: {
        id: null,
        exam_id: this.exam.id,
        text: '',
        desc: null,
        order: this.exam.questions.length + 1,
        type: null,
        category_id: null,
      },
    }
  },

  computed: {
    isPublish: function () {
      return this.form.status === 2
    },

    toggleClass: function() {
      return ( this.form.status ) ? 'bg-secondary-500' : 'bg-gray-200'
    },

    toggleSortingClass() {
      return this.showSortingMode ? 'bg-secondary-500' : 'bg-gray-200 peer-checked:bg-blue-600'
    },
  },

  mounted() {
    this.selectedQuestions = this.form.questions
  },

  methods: {
    update() {
      if( this.form.status ) {
        this.form.status = 1
      } else {
        this.form.status = 2
      }
      this.form.put(`/exam/${this.exam.id}`, {
        onSuccess: ( response ) => {
          if( this.form.status === 2 ) {
            this.form.status = false;
          }
        },
        onError: ( error ) => { console.log( error )},
      })
    },

    destroy() {
      if (confirm('Are you sure you want to delete this exam?')) {
        this.$inertia.delete(`/exam/${this.exam.id}`)
      }
    },

    /**
     * Order of the question changed and therefore must be saved
     */
    orderChanged: function ( data, some ) {
      this.wasOrderChanged = true
    },

    saveOrder: async function( type = null ) {
      this.isOrderLoading = true
      let data = {
        questions: ( type === 'all' ) ? 'all' : this.selectedQuestions,
      }
      await postQuestionOrder( this.exam.id, data )
      this.isOrderLoading = false
      this.wasOrderChanged = false
      // this.selectedQuestions = []
    },

    debounceAnswer(event) {
      this.message = null
      this.isTyping = true
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.isTyping = null
        this.keyword = event.target.value
        let keyword = this.keyword
        this.selectedQuestions = this.form.questions.filter( question => {
          return question.text.includes( keyword )
        })
      }, this.timeout)
    },

    addQuestion: function() {
      this.currentQuestion = this.newQuestionModal
      this.showQuestionModal = true
    },

    toggleQuestionModal: function( shouldShow = null ) {
      if( shouldShow ) {
        this.showQuestionModal = shouldShow
      } else {
        this.showQuestionModal = !this.showQuestionModal
      }
    },

    prepareQuestionModal: function( question ) {
      this.currentQuestion = question
      this.showQuestionModal = true
    },

    onQuestionUpdated: function( question ) {
      this.currentQuestion = null
      for( let i = 0; i < this.form.questions.length; i++ ) {
        if( this.form.questions[i].id === question.id ) {
          this.form.questions[i] = question
        }
      }
      this.selectedQuestions = this.form.questions
      this.toggleQuestionModal()
    },

    onQuestionCreated: function( question ) {
      this.currentQuestion = null
      this.form.questions.push( question )
      this.selectedQuestions = this.form.questions
      this.toggleQuestionModal()
      this.prepareQuestionModal( question )
    },

    onQuestionDeleted: function( question ) {
      this.currentQuestion = null
      this.toggleQuestionModal()
      this.saveOrder('all')
    },
  },
}
</script>
